var infraestructuras = angular.module('infraestructuras');

infraestructuras.controller('infraestructurasController', ['$rootScope', '$scope', '$location', 'infraestructurasService', '$routeParams', 'authenticationInfo', 'authenticationService', '$sce',
    function ($rootScope, $scope, $location, infraestructurasService, $routeParams, authenticationInfo, authenticationService, $sce) {

        $scope.authentication = authenticationInfo;


        $rootScope.categoria = $routeParams.id;


        // $scope.ListaInspecciones = infraestructurasService.getTodasLasInspecciones($rootScope.categoria);


        //infraestructurasService.getTodasLasInspecciones($rootScope.categoria)
        //    .then(function (response) {
        //        var data = response.data;
        //        $scope.ListaInspecciones = data;
        //    });

        // $scope.InspeccionId = 37;

        switch ($rootScope.categoria) {

            case '1':
                $scope.categoriaIcono = "active icon-puentes";
                infraestructurasService.getInfraestructurasCategoria($routeParams.id, $rootScope.usuario)
                    .then(function (response) {
                        var data = response.data;
                        $scope.infraestructuras = data;

                        for (var i = 0; i < $scope.infraestructuras.length; ++i) {
                            if ($scope.infraestructuras[i].IndiceInspeccion.Color == "Verde")
                                $scope.infraestructuras[i].IndiceInspeccionInfraestructura = "infraestructura-box infraestructura-status-0 row";
                            else if ($scope.infraestructuras[i].IndiceInspeccion.Color == "Amarillo")
                                $scope.infraestructuras[i].IndiceInspeccionInfraestructura = "infraestructura-box infraestructura-status-1 row";
                            else if ($scope.infraestructuras[i].IndiceInspeccion.Color == "Naranja")
                                $scope.infraestructuras[i].IndiceInspeccionInfraestructura = "infraestructura-box infraestructura-status-2 row";
                            else if ($scope.infraestructuras[i].IndiceInspeccion.Color == "Rojo")
                                $scope.infraestructuras[i].IndiceInspeccionInfraestructura = "infraestructura-box infraestructura-status-3 row";

                            $scope.infraestructuras[i].Tiempo = $sce.trustAsHtml($scope.infraestructuras[i].Tiempo);

                            (function (infraestructura) {
                                setTimeout(function () {
                                    const divTemporal = document.createElement("div");
                                    divTemporal.innerHTML = infraestructura.Tiempo.toString();

                                    const script = divTemporal.querySelector("script");
                                    const divWidget = divTemporal.querySelector("div");

                                    if (script && divWidget) {
                                        const container = document.getElementById("widget-tiempo-" + infraestructura.Id);
                                        if (container) {
                                            container.innerHTML = "";
                                            container.appendChild(divWidget);

                                            const newScript = document.createElement("script");
                                            newScript.type = "text/javascript";
                                            newScript.src = script.src;
                                            document.body.appendChild(newScript);
                                        }
                                    }
                                }, 0);
                            })($scope.infraestructuras[i]);

                        }


                        var myLatlng = new google.maps.LatLng(43.20523189138532, -2.8637797716569295);

                        var myOptions = {
                            zoom: 14,
                            center: myLatlng,
                            mapTypeId: google.maps.MapTypeId.ROADMAP
                        };

                        $scope.map = new google.maps.Map(document.getElementById("map_canvas"), myOptions);


                        var icono = "http://maps.google.com/mapfiles/ms/icons/red-dot.png"

                        angular.forEach($scope.infraestructuras, function (infraestructura) {
                            myLatlng = new google.maps.LatLng(infraestructura.PosicionamientoYInfraestructura, infraestructura.PosicionamientoXInfraestructura);

                            if (infraestructura.IndiceInspeccion.Color == "Rojo") {
                                icono = "http://maps.google.com/mapfiles/ms/icons/red-dot.png"
                                var markerGreen = new google.maps.Marker({
                                    position: myLatlng,
                                    title: infraestructura.Descripcion,
                                    draggable: false,
                                    icon: {
                                        url: icono
                                    }
                                });
                                markerGreen.setMap($scope.map);
                            }
                            else {
                                if (infraestructura.IndiceInspeccion.Color == "Naranja") {
                                    icono = "http://maps.google.com/mapfiles/ms/icons/orange-dot.png"
                                    var markerOrange = new google.maps.Marker({
                                        position: myLatlng,
                                        title: infraestructura.Descripcion,
                                        draggable: false,
                                        icon: {
                                            url: icono
                                        }
                                    });
                                    markerOrange.setMap($scope.map);
                                }
                                else {
                                    if (infraestructura.IndiceInspeccion.Color == "Amarillo") {
                                        icono = "http://maps.google.com/mapfiles/ms/icons/yellow-dot.png"
                                        var markerYellow = new google.maps.Marker({
                                            position: myLatlng,
                                            title: infraestructura.Descripcion,
                                            draggable: false,
                                            icon: {
                                                url: icono
                                            }
                                        });
                                        markerYellow.setMap($scope.map);
                                    }
                                    else {
                                        icono = "http://maps.google.com/mapfiles/ms/icons/green-dot.png"
                                        var markerRed = new google.maps.Marker({
                                            position: myLatlng,
                                            title: infraestructura.Descripcion,
                                            draggable: false,
                                            icon: {
                                                url: icono
                                            }
                                        });
                                        markerRed.setMap($scope.map);
                                    }
                                }
                            }

                        });

                    });
                break;

            case '2': $scope.categoriaIcono = "active icon-tuneles";
                infraestructurasService.getInfraestructurasCategoria($routeParams.id, $rootScope.usuario)
                    .then(function (response) {
                        var data = response.data;
                        $scope.infraestructuras = data;

                        for (var i = 0; i < $scope.infraestructuras.length; ++i) {
                            if ($scope.infraestructuras[i].IndiceInspeccion.Color == "Verde")
                                $scope.infraestructuras[i].IndiceInspeccionInfraestructura = "infraestructura-box infraestructura-status-0 row";
                            else if ($scope.infraestructuras[i].IndiceInspeccion.Color == "Amarillo")
                                $scope.infraestructuras[i].IndiceInspeccionInfraestructura = "infraestructura-box infraestructura-status-1 row";
                            else if ($scope.infraestructuras[i].IndiceInspeccion.Color == "Naranja")
                                $scope.infraestructuras[i].IndiceInspeccionInfraestructura = "infraestructura-box infraestructura-status-2 row";
                            else if ($scope.infraestructuras[i].IndiceInspeccion.Color == "Rojo")
                                $scope.infraestructuras[i].IndiceInspeccionInfraestructura = "infraestructura-box infraestructura-status-3 row";

                            $scope.infraestructuras[i].Tiempo = $sce.trustAsHtml($scope.infraestructuras[i].Tiempo);

                            (function (infraestructura) {
                                setTimeout(function () {
                                    const divTemporal = document.createElement("div");
                                    divTemporal.innerHTML = infraestructura.Tiempo.toString();

                                    const script = divTemporal.querySelector("script");
                                    const divWidget = divTemporal.querySelector("div");

                                    if (script && divWidget) {
                                        const container = document.getElementById("widget-tiempo-" + infraestructura.Id);
                                        if (container) {
                                            container.innerHTML = "";
                                            container.appendChild(divWidget);

                                            const newScript = document.createElement("script");
                                            newScript.type = "text/javascript";
                                            newScript.src = script.src;
                                            document.body.appendChild(newScript);
                                        }
                                    }
                                }, 0);
                            })($scope.infraestructuras[i]);


                        }

                        var myLatlng = new google.maps.LatLng(43.20523189138532, -2.8637797716569295);

                        var myOptions = {
                            zoom: 14,
                            center: myLatlng,
                            mapTypeId: google.maps.MapTypeId.ROADMAP
                        };

                        $scope.map = new google.maps.Map(document.getElementById("map_canvas"), myOptions);


                        var icono = "http://maps.google.com/mapfiles/ms/icons/red-dot.png"

                        angular.forEach($scope.infraestructuras, function (infraestructura) {
                            myLatlng = new google.maps.LatLng(infraestructura.PosicionamientoYInfraestructura, infraestructura.PosicionamientoXInfraestructura);

                            if (infraestructura.IndiceInspeccion.Color == "Rojo") {
                                icono = "http://maps.google.com/mapfiles/ms/icons/red-dot.png"
                                var markerGreen = new google.maps.Marker({
                                    position: myLatlng,
                                    title: infraestructura.Descripcion,
                                    draggable: false,
                                    icon: {
                                        url: icono
                                    }
                                });
                                markerGreen.setMap($scope.map);
                            }
                            else {
                                if (infraestructura.IndiceInspeccion.Color == "Naranja") {
                                    icono = "http://maps.google.com/mapfiles/ms/icons/orange-dot.png"
                                    var markerOrange = new google.maps.Marker({
                                        position: myLatlng,
                                        title: infraestructura.Descripcion,
                                        draggable: false,
                                        icon: {
                                            url: icono
                                        }
                                    });
                                    markerOrange.setMap($scope.map);
                                }
                                else {
                                    if (infraestructura.IndiceInspeccion.Color == "Amarillo") {
                                        icono = "http://maps.google.com/mapfiles/ms/icons/yellow-dot.png"
                                        var markerYellow = new google.maps.Marker({
                                            position: myLatlng,
                                            title: infraestructura.Descripcion,
                                            draggable: false,
                                            icon: {
                                                url: icono
                                            }
                                        });
                                        markerYellow.setMap($scope.map);
                                    }
                                    else {
                                        icono = "http://maps.google.com/mapfiles/ms/icons/green-dot.png"
                                        var markerRed = new google.maps.Marker({
                                            position: myLatlng,
                                            title: infraestructura.Descripcion,
                                            draggable: false,
                                            icon: {
                                                url: icono
                                            }
                                        });
                                        markerRed.setMap($scope.map);
                                    }
                                }
                            }

                        });

                    });
                break;

            case '3': $scope.categoriaIcono = "active icon-presas";
                infraestructurasService.getInfraestructurasCategoria($routeParams.id, $rootScope.usuario)
                    .then(function (response) {
                        var data = response.data;
                        $scope.infraestructuras = data;

                        for (var i = 0; i < $scope.infraestructuras.length; ++i) {
                            if ($scope.infraestructuras[i].IndiceInspeccion.Color == "Verde")
                                $scope.infraestructuras[i].IndiceInspeccionInfraestructura = "infraestructura-box infraestructura-status-0 row";
                            else if ($scope.infraestructuras[i].IndiceInspeccion.Color == "Amarillo")
                                $scope.infraestructuras[i].IndiceInspeccionInfraestructura = "infraestructura-box infraestructura-status-1 row";
                            else if ($scope.infraestructuras[i].IndiceInspeccion.Color == "Naranja")
                                $scope.infraestructuras[i].IndiceInspeccionInfraestructura = "infraestructura-box infraestructura-status-2 row";
                            else if ($scope.infraestructuras[i].IndiceInspeccion.Color == "Rojo")
                                $scope.infraestructuras[i].IndiceInspeccionInfraestructura = "infraestructura-box infraestructura-status-3 row";

                            //$scope.infraestructuras[i].Tiempo = $sce.trustAsHtml($scope.infraestructuras[i].Tiempo);
                            $scope.infraestructuras[i].Tiempo = null;

                            (function (infraestructura) {
                                setTimeout(function () {
                                    const divTemporal = document.createElement("div");
                                    divTemporal.innerHTML = infraestructura.Tiempo.toString();

                                    const script = divTemporal.querySelector("script");
                                    const divWidget = divTemporal.querySelector("div");

                                    if (script && divWidget) {
                                        const container = document.getElementById("widget-tiempo-" + infraestructura.Id);
                                        if (container) {
                                            container.innerHTML = "";
                                            container.appendChild(divWidget);

                                            const newScript = document.createElement("script");
                                            newScript.type = "text/javascript";
                                            newScript.src = script.src;
                                            document.body.appendChild(newScript);
                                        }
                                    }
                                }, 0);
                            })($scope.infraestructuras[i]);

                        }

                        var myLatlng = new google.maps.LatLng(43.20523189138532, -2.8637797716569295);

                        var myOptions = {
                            zoom: 14,
                            center: myLatlng,
                            mapTypeId: google.maps.MapTypeId.ROADMAP
                        };

                        $scope.map = new google.maps.Map(document.getElementById("map_canvas"), myOptions);


                        var icono = "http://maps.google.com/mapfiles/ms/icons/red-dot.png"

                        angular.forEach($scope.infraestructuras, function (infraestructura) {
                            myLatlng = new google.maps.LatLng(infraestructura.PosicionamientoYInfraestructura, infraestructura.PosicionamientoXInfraestructura);

                            if (infraestructura.IndiceInspeccion.Color == "Rojo") {
                                icono = "http://maps.google.com/mapfiles/ms/icons/red-dot.png"
                                var markerGreen = new google.maps.Marker({
                                    position: myLatlng,
                                    title: infraestructura.Descripcion,
                                    draggable: false,
                                    icon: {
                                        url: icono
                                    }
                                });
                                markerGreen.setMap($scope.map);
                            }
                            else {
                                if (infraestructura.IndiceInspeccion.Color == "Naranja") {
                                    icono = "http://maps.google.com/mapfiles/ms/icons/orange-dot.png"
                                    var markerOrange = new google.maps.Marker({
                                        position: myLatlng,
                                        title: infraestructura.Descripcion,
                                        draggable: false,
                                        icon: {
                                            url: icono
                                        }
                                    });
                                    markerOrange.setMap($scope.map);
                                }
                                else {
                                    if (infraestructura.IndiceInspeccion.Color == "Amarillo") {
                                        icono = "http://maps.google.com/mapfiles/ms/icons/yellow-dot.png"
                                        var markerYellow = new google.maps.Marker({
                                            position: myLatlng,
                                            title: infraestructura.Descripcion,
                                            draggable: false,
                                            icon: {
                                                url: icono
                                            }
                                        });
                                        markerYellow.setMap($scope.map);
                                    }
                                    else {
                                        icono = "http://maps.google.com/mapfiles/ms/icons/green-dot.png"
                                        var markerRed = new google.maps.Marker({
                                            position: myLatlng,
                                            title: infraestructura.Descripcion,
                                            draggable: false,
                                            icon: {
                                                url: icono
                                            }
                                        });
                                        markerRed.setMap($scope.map);
                                    }
                                }
                            }

                        });

                    });
                break;


            case '4': $scope.categoriaIcono = "active icon-obras";
                infraestructurasService.getInfraestructurasCategoria($routeParams.id, $rootScope.usuario)
                    .then(function (response) {
                        var data = response.data;
                        $scope.infraestructuras = data;

                        for (var i = 0; i < $scope.infraestructuras.length; ++i) {
                            if ($scope.infraestructuras[i].IndiceInspeccion.Color == "Verde")
                                $scope.infraestructuras[i].IndiceInspeccionInfraestructura = "infraestructura-box infraestructura-status-0 row";
                            else if ($scope.infraestructuras[i].IndiceInspeccion.Color == "Amarillo")
                                $scope.infraestructuras[i].IndiceInspeccionInfraestructura = "infraestructura-box infraestructura-status-1 row";
                            else if ($scope.infraestructuras[i].IndiceInspeccion.Color == "Naranja")
                                $scope.infraestructuras[i].IndiceInspeccionInfraestructura = "infraestructura-box infraestructura-status-2 row";
                            else if ($scope.infraestructuras[i].IndiceInspeccion.Color == "Rojo")
                                $scope.infraestructuras[i].IndiceInspeccionInfraestructura = "infraestructura-box infraestructura-status-3 row";

                            $scope.infraestructuras[i].Tiempo = $sce.trustAsHtml($scope.infraestructuras[i].Tiempo);

                            (function (infraestructura) {
                                setTimeout(function () {
                                    const divTemporal = document.createElement("div");
                                    divTemporal.innerHTML = infraestructura.Tiempo.toString();

                                    const script = divTemporal.querySelector("script");
                                    const divWidget = divTemporal.querySelector("div");

                                    if (script && divWidget) {
                                        const container = document.getElementById("widget-tiempo-" + infraestructura.Id);
                                        if (container) {
                                            container.innerHTML = "";
                                            container.appendChild(divWidget);

                                            const newScript = document.createElement("script");
                                            newScript.type = "text/javascript";
                                            newScript.src = script.src;
                                            document.body.appendChild(newScript);
                                        }
                                    }
                                }, 0);
                            })($scope.infraestructuras[i]);

                        }

                        var myLatlng = new google.maps.LatLng(43.20523189138532, -2.8637797716569295);

                        var myOptions = {
                            zoom: 14,
                            center: myLatlng,
                            mapTypeId: google.maps.MapTypeId.ROADMAP
                        };

                        $scope.map = new google.maps.Map(document.getElementById("map_canvas"), myOptions);


                        var icono = "http://maps.google.com/mapfiles/ms/icons/red-dot.png"

                        angular.forEach($scope.infraestructuras, function (infraestructura) {
                            myLatlng = new google.maps.LatLng(infraestructura.PosicionamientoYInfraestructura, infraestructura.PosicionamientoXInfraestructura);

                            if (infraestructura.IndiceInspeccion.Color == "Rojo") {
                                icono = "http://maps.google.com/mapfiles/ms/icons/red-dot.png"
                                var markerGreen = new google.maps.Marker({
                                    position: myLatlng,
                                    title: infraestructura.Descripcion,
                                    draggable: false,
                                    icon: {
                                        url: icono
                                    }
                                });
                                markerGreen.setMap($scope.map);
                            }
                            else {
                                if (infraestructura.IndiceInspeccion.Color == "Naranja") {
                                    icono = "http://maps.google.com/mapfiles/ms/icons/orange-dot.png"
                                    var markerOrange = new google.maps.Marker({
                                        position: myLatlng,
                                        title: infraestructura.Descripcion,
                                        draggable: false,
                                        icon: {
                                            url: icono
                                        }
                                    });
                                    markerOrange.setMap($scope.map);
                                }
                                else {
                                    if (infraestructura.IndiceInspeccion.Color == "Amarillo") {
                                        icono = "http://maps.google.com/mapfiles/ms/icons/yellow-dot.png"
                                        var markerYellow = new google.maps.Marker({
                                            position: myLatlng,
                                            title: infraestructura.Descripcion,
                                            draggable: false,
                                            icon: {
                                                url: icono
                                            }
                                        });
                                        markerYellow.setMap($scope.map);
                                    }
                                    else {
                                        icono = "http://maps.google.com/mapfiles/ms/icons/green-dot.png"
                                        var markerRed = new google.maps.Marker({
                                            position: myLatlng,
                                            title: infraestructura.Descripcion,
                                            draggable: false,
                                            icon: {
                                                url: icono
                                            }
                                        });
                                        markerRed.setMap($scope.map);
                                    }
                                }
                            }

                        });

                    });
                break;

            case '5': $scope.categoriaIcono = "active icon-edar";
                infraestructurasService.getInfraestructurasCategoria($routeParams.id, $rootScope.usuario)
                    .then(function (response) {
                        var data = response.data;
                        $scope.infraestructuras = data;

                        for (var i = 0; i < $scope.infraestructuras.length; ++i) {
                            if ($scope.infraestructuras[i].IndiceInspeccion.Color == "Verde")
                                $scope.infraestructuras[i].IndiceInspeccionInfraestructura = "infraestructura-box infraestructura-status-0 row";
                            else if ($scope.infraestructuras[i].IndiceInspeccion.Color == "Amarillo")
                                $scope.infraestructuras[i].IndiceInspeccionInfraestructura = "infraestructura-box infraestructura-status-1 row";
                            else if ($scope.infraestructuras[i].IndiceInspeccion.Color == "Naranja")
                                $scope.infraestructuras[i].IndiceInspeccionInfraestructura = "infraestructura-box infraestructura-status-2 row";
                            else if ($scope.infraestructuras[i].IndiceInspeccion.Color == "Rojo")
                                $scope.infraestructuras[i].IndiceInspeccionInfraestructura = "infraestructura-box infraestructura-status-3 row";

                            $scope.infraestructuras[i].Tiempo = $sce.trustAsHtml($scope.infraestructuras[i].Tiempo);

                            (function (infraestructura) {
                                setTimeout(function () {
                                    const divTemporal = document.createElement("div");
                                    divTemporal.innerHTML = infraestructura.Tiempo.toString();

                                    const script = divTemporal.querySelector("script");
                                    const divWidget = divTemporal.querySelector("div");

                                    if (script && divWidget) {
                                        const container = document.getElementById("widget-tiempo-" + infraestructura.Id);
                                        if (container) {
                                            container.innerHTML = "";
                                            container.appendChild(divWidget);

                                            const newScript = document.createElement("script");
                                            newScript.type = "text/javascript";
                                            newScript.src = script.src;
                                            document.body.appendChild(newScript);
                                        }
                                    }
                                }, 0);
                            })($scope.infraestructuras[i]);

                        }

                        var myLatlng = new google.maps.LatLng(43.20523189138532, -2.8637797716569295);

                        var myOptions = {
                            zoom: 14,
                            center: myLatlng,
                            mapTypeId: google.maps.MapTypeId.ROADMAP
                        };

                        $scope.map = new google.maps.Map(document.getElementById("map_canvas"), myOptions);


                        var icono = "http://maps.google.com/mapfiles/ms/icons/red-dot.png"

                        angular.forEach($scope.infraestructuras, function (infraestructura) {
                            myLatlng = new google.maps.LatLng(infraestructura.PosicionamientoYInfraestructura, infraestructura.PosicionamientoXInfraestructura);

                            if (infraestructura.IndiceInspeccion.Color == "Rojo") {
                                icono = "http://maps.google.com/mapfiles/ms/icons/red-dot.png"
                                var markerGreen = new google.maps.Marker({
                                    position: myLatlng,
                                    title: infraestructura.Descripcion,
                                    draggable: false,
                                    icon: {
                                        url: icono
                                    }
                                });
                                markerGreen.setMap($scope.map);
                            }
                            else {
                                if (infraestructura.IndiceInspeccion.Color == "Naranja") {
                                    icono = "http://maps.google.com/mapfiles/ms/icons/orange-dot.png"
                                    var markerOrange = new google.maps.Marker({
                                        position: myLatlng,
                                        title: infraestructura.Descripcion,
                                        draggable: false,
                                        icon: {
                                            url: icono
                                        }
                                    });
                                    markerOrange.setMap($scope.map);
                                }
                                else {
                                    if (infraestructura.IndiceInspeccion.Color == "Amarillo") {
                                        icono = "http://maps.google.com/mapfiles/ms/icons/yellow-dot.png"
                                        var markerYellow = new google.maps.Marker({
                                            position: myLatlng,
                                            title: infraestructura.Descripcion,
                                            draggable: false,
                                            icon: {
                                                url: icono
                                            }
                                        });
                                        markerYellow.setMap($scope.map);
                                    }
                                    else {
                                        icono = "http://maps.google.com/mapfiles/ms/icons/green-dot.png"
                                        var markerRed = new google.maps.Marker({
                                            position: myLatlng,
                                            title: infraestructura.Descripcion,
                                            draggable: false,
                                            icon: {
                                                url: icono
                                            }
                                        });
                                        markerRed.setMap($scope.map);
                                    }
                                }
                            }

                        });

                    });
                break;

            case '6': $scope.categoriaIcono = "active icon-edificios";
                infraestructurasService.getInfraestructurasCategoria($routeParams.id, $rootScope.usuario)
                    .then(function (response) {
                        var data = response.data;
                        $scope.infraestructuras = data;

                        for (var i = 0; i < $scope.infraestructuras.length; ++i) {
                            if ($scope.infraestructuras[i].IndiceInspeccion.Color == "Verde")
                                $scope.infraestructuras[i].IndiceInspeccionInfraestructura = "infraestructura-box infraestructura-status-0 row";
                            else if ($scope.infraestructuras[i].IndiceInspeccion.Color == "Amarillo")
                                $scope.infraestructuras[i].IndiceInspeccionInfraestructura = "infraestructura-box infraestructura-status-1 row";
                            else if ($scope.infraestructuras[i].IndiceInspeccion.Color == "Naranja")
                                $scope.infraestructuras[i].IndiceInspeccionInfraestructura = "infraestructura-box infraestructura-status-2 row";
                            else if ($scope.infraestructuras[i].IndiceInspeccion.Color == "Rojo")
                                $scope.infraestructuras[i].IndiceInspeccionInfraestructura = "infraestructura-box infraestructura-status-3 row";

                            $scope.infraestructuras[i].Tiempo = $sce.trustAsHtml($scope.infraestructuras[i].Tiempo);

                            (function (infraestructura) {
                                setTimeout(function () {
                                    const divTemporal = document.createElement("div");
                                    divTemporal.innerHTML = infraestructura.Tiempo.toString();

                                    const script = divTemporal.querySelector("script");
                                    const divWidget = divTemporal.querySelector("div");

                                    if (script && divWidget) {
                                        const container = document.getElementById("widget-tiempo-" + infraestructura.Id);
                                        if (container) {
                                            container.innerHTML = "";
                                            container.appendChild(divWidget);

                                            const newScript = document.createElement("script");
                                            newScript.type = "text/javascript";
                                            newScript.src = script.src;
                                            document.body.appendChild(newScript);
                                        }
                                    }
                                }, 0);
                            })($scope.infraestructuras[i]);

                        }

                        var myLatlng = new google.maps.LatLng(43.20523189138532, -2.8637797716569295);

                        var myOptions = {
                            zoom: 14,
                            center: myLatlng,
                            mapTypeId: google.maps.MapTypeId.ROADMAP
                        };

                        $scope.map = new google.maps.Map(document.getElementById("map_canvas"), myOptions);


                        var icono = "http://maps.google.com/mapfiles/ms/icons/red-dot.png"

                        angular.forEach($scope.infraestructuras, function (infraestructura) {
                            myLatlng = new google.maps.LatLng(infraestructura.PosicionamientoYInfraestructura, infraestructura.PosicionamientoXInfraestructura);

                            if (infraestructura.IndiceInspeccion.Color == "Rojo") {
                                icono = "http://maps.google.com/mapfiles/ms/icons/red-dot.png"
                                var markerGreen = new google.maps.Marker({
                                    position: myLatlng,
                                    title: infraestructura.Descripcion,
                                    draggable: false,
                                    icon: {
                                        url: icono
                                    }
                                });
                                markerGreen.setMap($scope.map);
                            }
                            else {
                                if (infraestructura.IndiceInspeccion.Color == "Naranja") {
                                    icono = "http://maps.google.com/mapfiles/ms/icons/orange-dot.png"
                                    var markerOrange = new google.maps.Marker({
                                        position: myLatlng,
                                        title: infraestructura.Descripcion,
                                        draggable: false,
                                        icon: {
                                            url: icono
                                        }
                                    });
                                    markerOrange.setMap($scope.map);
                                }
                                else {
                                    if (infraestructura.IndiceInspeccion.Color == "Amarillo") {
                                        icono = "http://maps.google.com/mapfiles/ms/icons/yellow-dot.png"
                                        var markerYellow = new google.maps.Marker({
                                            position: myLatlng,
                                            title: infraestructura.Descripcion,
                                            draggable: false,
                                            icon: {
                                                url: icono
                                            }
                                        });
                                        markerYellow.setMap($scope.map);
                                    }
                                    else {
                                        icono = "http://maps.google.com/mapfiles/ms/icons/green-dot.png"
                                        var markerRed = new google.maps.Marker({
                                            position: myLatlng,
                                            title: infraestructura.Descripcion,
                                            draggable: false,
                                            icon: {
                                                url: icono
                                            }
                                        });
                                        markerRed.setMap($scope.map);
                                    }
                                }
                            }

                        });

                    });
                break;

            case '21': $scope.categoriaIcono = "active icon-tuneles-ferroviarios";
                infraestructurasService.getDañosPorGravedadTodosLosTuneles($rootScope.categoria, $rootScope.usuario)
                    .then(function (response) {
                        var data = response.data;
                        $scope.infraestructuras = data;

                        for (var i = 0; i < $scope.infraestructuras.length; ++i) {
                            if ($scope.infraestructuras[i].IndiceInfraestructura.Color == "Verde")
                                $scope.infraestructuras[i].IndiceInspeccionInfraestructura = "infraestructura-box infraestructura-status-0 row";
                            else if ($scope.infraestructuras[i].IndiceInfraestructura.Color == "Amarillo")
                                $scope.infraestructuras[i].IndiceInspeccionInfraestructura = "infraestructura-box infraestructura-status-1 row";
                            else if ($scope.infraestructuras[i].IndiceInfraestructura.Color == "Naranja")
                                $scope.infraestructuras[i].IndiceInspeccionInfraestructura = "infraestructura-box infraestructura-status-2 row";
                            else if ($scope.infraestructuras[i].IndiceInfraestructura.Color == "Rojo")
                                $scope.infraestructuras[i].IndiceInspeccionInfraestructura = "infraestructura-box infraestructura-status-3 row";

                            $scope.infraestructuras[i].Tiempo = $sce.trustAsHtml($scope.infraestructuras[i].Tiempo);

                            (function (infraestructura) {
                                setTimeout(function () {
                                    const divTemporal = document.createElement("div");
                                    divTemporal.innerHTML = infraestructura.Tiempo.toString();

                                    const script = divTemporal.querySelector("script");
                                    const divWidget = divTemporal.querySelector("div");

                                    if (script && divWidget) {
                                        const container = document.getElementById("widget-tiempo-" + infraestructura.Id);
                                        if (container) {
                                            container.innerHTML = "";
                                            container.appendChild(divWidget);

                                            const newScript = document.createElement("script");
                                            newScript.type = "text/javascript";
                                            newScript.src = script.src;
                                            document.body.appendChild(newScript);
                                        }
                                    }
                                }, 0);
                            })($scope.infraestructuras[i]);

                        }


                        var myLatlng = new google.maps.LatLng(43.20523189138532, -2.8637797716569295);

                        var myOptions = {
                            zoom: 14,
                            center: myLatlng,
                            mapTypeId: google.maps.MapTypeId.ROADMAP
                        };

                        $scope.map = new google.maps.Map(document.getElementById("map_canvas"), myOptions);


                        var icono = "http://maps.google.com/mapfiles/ms/icons/red-dot.png"

                        angular.forEach($scope.infraestructuras, function (infraestructura) {
                            myLatlng = new google.maps.LatLng(infraestructura.PosicionamientoYInfraestructura, infraestructura.PosicionamientoXInfraestructura);

                            if (infraestructura.IndiceInfraestructura.Color == "Rojo") {
                                icono = "http://maps.google.com/mapfiles/ms/icons/red-dot.png"
                                var markerGreen = new google.maps.Marker({
                                    position: myLatlng,
                                    title: infraestructura.Descripcion,
                                    draggable: false,
                                    icon: {
                                        url: icono
                                    }
                                });
                                markerGreen.setMap($scope.map);
                            }
                            else {
                                if (infraestructura.IndiceInfraestructura.Color == "Naranja") {
                                    icono = "http://maps.google.com/mapfiles/ms/icons/orange-dot.png"
                                    var markerOrange = new google.maps.Marker({
                                        position: myLatlng,
                                        title: infraestructura.Descripcion,
                                        draggable: false,
                                        icon: {
                                            url: icono
                                        }
                                    });
                                    markerOrange.setMap($scope.map);
                                } else {
                                    if (infraestructura.IndiceInfraestructura.Color == "Amarillo") {
                                        icono = "http://maps.google.com/mapfiles/ms/icons/yellow-dot.png"
                                        var markerYellow = new google.maps.Marker({
                                            position: myLatlng,
                                            title: infraestructura.Descripcion,
                                            draggable: false,
                                            icon: {
                                                url: icono
                                            }
                                        });
                                        markerYellow.setMap($scope.map);
                                    }
                                    else {
                                        icono = "http://maps.google.com/mapfiles/ms/icons/green-dot.png"
                                        var markerRed = new google.maps.Marker({
                                            position: myLatlng,
                                            title: infraestructura.Descripcion,
                                            draggable: false,
                                            icon: {
                                                url: icono
                                            }
                                        });
                                        markerRed.setMap($scope.map);
                                    }
                                }
                            }

                        });


                    });

                // Silvia para sacar el grafico de gravedades por infraestructura

                //infraestructurasService.getInfraestructuraPorGravedad($rootScope.categoria)
                //    .then(function (response) {
                //        $scope.infraestructurasporgravedad = response.data;

                //        // Generar dinámicamente los labels y los datos basados en $scope.daños
                //        const labelsGr = $scope.infraestructurasporgravedad.map(function (d) {
                //            return d.Nombre || 'Sin nombre';
                //        });

                //        const dataGr = $scope.infraestructurasporgravedad.map(function (d) {
                //            // return d.Gravedad || 0;
                //            return 1;
                //        });

                //        // Mapa de colores y descripciones por IndiceEstado
                //        const colorMapByEstado = {
                //            1: 'rgba(0, 128, 0, 0.7)',    // Leve - Verde
                //            2: 'rgba(255, 255, 0, 0.7)',  // Moderado - Amarillo
                //            3: 'rgba(255, 165, 0, 0.7)',  // Severo - Naranja
                //            4: 'rgba(255, 0, 0, 0.7)'     // Crítico - Rojo
                //        };
                //        const borderColorMapByEstado = {
                //            1: 'rgba(0, 100, 0, 1)',      // Verde oscuro
                //            2: 'rgba(200, 200, 0, 1)',    // Amarillo oscuro
                //            3: 'rgba(200, 100, 0, 1)',    // Naranja oscuro
                //            4: 'rgba(150, 0, 0, 1)'       // Rojo oscuro
                //        };

                //        const descripcionMapByEstado = {
                //            1: 'Leve',
                //            2: 'Moderado',
                //            3: 'Severo',
                //            4: 'Crítico'
                //        };

                //        const backgroundColors = $scope.infraestructurasporgravedad.map(function (d) {
                //            return colorMapByEstado[d.Gravedad];
                //        });

                //        const borderColors = $scope.infraestructurasporgravedad.map(function (d) {
                //            return borderColorMapByEstado[d.Gravedad];
                //        });


                //        const chartData = {
                //            labels: labelsGr, // Etiquetas dinámicas
                //            datasets: [{
                //                label: "",
                //                data: dataGr,
                //                backgroundColor: backgroundColors,
                //                borderColor: borderColors,
                //                borderWidth: 1
                //            }]
                //        };

                //        const chartConfig = {
                //            type: 'pie',
                //            data: chartData,
                //            options: {
                //                responsive: true,
                //                maintainAspectRatio: true,
                //                plugins: {
                //                    legend: {
                //                        display: false,
                //                    },
                //                    tooltip: {
                //                        enabled: true, // Mostrar valores al pasar el mouse
                //                    },
                //                    datalabels: {
                //                        color: '#000',
                //                        font: {
                //                            size: 12,
                //                            weight: 'bold'
                //                        },

                //                        formatter: function (value, context) {
                //                            const data = context.chart.data.datasets[0].data;
                //                            //const total = data.reduce((acc, val) => acc + val, 0);
                //                            const total = ctx.chart.data.datasets[0].data.reduce(function (sum, val) {
                //                                return sum + val;
                //                            }, 0);
                //                            const percentage = (value / total) * 100;
                //                            return percentage.toFixed(1) + '%';
                //                        }
                //                    }
                //                },
                //                layout: {
                //                    padding: 20 // Añade espacio alrededor del gráfico
                //                }
                //            }
                //        };

                //        // Creación del gráfico

                //        const ctx = document.getElementById('graficoTunelesPorGravedad').getContext('2d');
                //        document.getElementById('graficoTunelesPorGravedad').width = 230;
                //        document.getElementById('graficoTunelesPorGravedad').height = 230;

                //        const indicePieChart = new Chart(ctx, chartConfig);

                //    });


                //  BUCLE PARA TODAS LAS INSPECCIONES


                infraestructurasService.getTodasLasInspecciones($rootScope.categoria)
                    .then(function (response) {
                        const inspecciones = response.data;

                        // Agrupar por túnel o infraestructura (usa el campo adecuado, aquí supongo TunelId)
                        const inspeccionesPorTunel = {};
                        inspecciones.forEach(function (inspeccion) {
                            var tunelId = inspeccion.TunelId;
                            if (!inspeccionesPorTunel[tunelId]) {
                                inspeccionesPorTunel[tunelId] = [];
                            }
                            inspeccionesPorTunel[tunelId].push(inspeccion);
                        });

                        // Tomar la inspección más reciente de cada túnel
                        var ultimasInspecciones = [];
                        for (var key in inspeccionesPorTunel) {
                            var listaInspecciones = inspeccionesPorTunel[key];
                            listaInspecciones.sort(function (a, b) {
                                return new Date(b.FechaInicio) - new Date(a.FechaInicio);
                            });
                            ultimasInspecciones.push(listaInspecciones[0]);
                        }

                        const totalesPorGravedad = {};
                        let pendientes = ultimasInspecciones.length;

                        if (pendientes === 0) return;

                        ultimasInspecciones.forEach(function (inspeccion) {
                            infraestructurasService.getDañosPorGravedad(inspeccion.Id)
                                .then(function (resp) {
                                    const daños = resp.data;

                                    daños.forEach(function (d) {
                                        const gravedad = d.GravedadDaño || 'N/A';
                                        const conteo = d.Conteo || 0;

                                        if (!totalesPorGravedad[gravedad]) {
                                            totalesPorGravedad[gravedad] = 0;
                                        }

                                        totalesPorGravedad[gravedad] += conteo;
                                    });

                                    pendientes--;

                                    if (pendientes === 0) {
                                        generarGrafico(totalesPorGravedad);
                                    }
                                });
                        });

                        function generarGrafico(totalesPorGravedad) {
                            const colorMap = {
                                'Leve': 'rgba(0, 128, 0, 0.7)',
                                'Moderado': 'rgba(255, 255, 0, 0.7)',
                                'Severo': 'rgba(255, 165, 0, 0.7)',
                                'Critico': 'rgba(255, 0, 0, 0.7)',
                                'N/A': 'rgba(128, 128, 128, 0.7)'
                            };

                            const darkerColorMap = {
                                'Leve': 'rgba(0, 100, 0, 1)',
                                'Moderado': 'rgba(200, 200, 0, 1)',
                                'Severo': 'rgba(200, 100, 0, 1)',
                                'Critico': 'rgba(150, 0, 0, 1)',
                                'N/A': 'rgba(80, 80, 80, 1)'
                            };

                            const labels = Object.keys(totalesPorGravedad);
                            const data = labels.map(function (label) {
                                return totalesPorGravedad[label];
                            });

                            const backgroundColors = labels.map(function (label) {
                                return colorMap[label];
                            });

                            const borderColors = labels.map(function (label) {
                                return darkerColorMap[label];
                            });

                            const config = {
                                type: 'pie',
                                data: {
                                    labels: labels,
                                    datasets: [{
                                        label: 'Distribución Total de Daños',
                                        data: data,
                                        backgroundColor: backgroundColors,
                                        borderColor: borderColors,
                                        borderWidth: 1
                                    }]
                                },
                                options: {
                                    responsive: true,
                                    plugins: {
                                        legend: {
                                            // position: 'right'
                                            display: false, // Oculta la leyenda
                                        },
                                        tooltip: {
                                            enabled: true
                                        },
                                        datalabels: {
                                            color: '#000',
                                            font: { size: 12, weight: 'bold' },
                                            //formatter: function (value, ctx) {
                                            //    const total = ctx.chart.data.datasets[0].data.reduce((sum, val) => sum + val, 0);
                                            //    return ((value / total) * 100).toFixed(2) + '%';

                                            formatter: function (value, ctx) {
                                                const data = ctx.chart.data.datasets[0].data;
                                                const total = ctx.chart.data.datasets[0].data.reduce(function (sum, val) {
                                                    return sum + val;
                                                }, 0);
                                                const percentage = (value / total) * 100;
                                                return percentage.toFixed(1) + '%';
                                            }
                                        }
                                    },
                                    layout: { padding: 20 }
                                }
                            };

                            const ctx = document.getElementById('graficoDaniosPorGravedad').getContext('2d');
                            //new Chart(ctx, config);
                            const damagePieChartGr = new Chart(ctx, config);
                        }
                    });



                // FIN TODAS LAS INSPECCIONES



                break;
        }



        $scope.verCategorias = function () {
            $rootScope.inspeccionUrl = false;
            $rootScope.parteUrl = false;
            $location.path('/categorias');
        };

        $scope.verInfraestructura = function (idInfraestructura, categoria) {
            if (categoria == '4') {
                $rootScope.parteUrl = true;
            }
            $location.path('/infraestructura/' + idInfraestructura);

        };

        $scope.irInfraestructura = function (PosicionamientoYInfraestructura, PosicionamientoXInfraestructura) {

            myLatlng = new google.maps.LatLng(PosicionamientoYInfraestructura, PosicionamientoXInfraestructura);

            $scope.map.panTo(myLatlng);
        };

    }]);

